import React from 'react';
import {ListItem} from '../List/ListItem';
import type {ListItemProps} from '../List/ListItem';
import {styled} from '@mui/material';

export interface NavItemProps extends ListItemProps {
    /**
     * Nest-level of a recursive Nav Item
     */
    level?: number;
}

const StyledListItem = styled(ListItem)<NavItemProps>({
    display: 'block',
    padding: 0
});

export const NavItem = React.forwardRef<HTMLLIElement, NavItemProps>(({
    children, ...props
}, ref) => {
    return (
        <StyledListItem
            {...props}
            ref={ref}
        >
            {children}
        </StyledListItem>
    );
});

NavItem.displayName = 'NavItem';
